export const env = {
  // From .env
  NX_API_URL: process.env.NX_API_URL || process.env.NX?.NX_API_URL,
  NX_PORTAL_URL: process.env.NX_PORTAL_URL || process.env.NX?.NX_PORTAL_URL,

  NX_B2C_AUTHORITY:
    process.env.NX_B2C_AUTHORITY || process.env.NX?.NX_B2C_AUTHORITY,
  NX_B2C_SIGNIN_POLICY:
    process.env.NX_B2C_SIGNIN_POLICY || process.env.NX?.NX_B2C_SIGNIN_POLICY,
  NX_B2C_RESET_PASSWORD_POLICY:
    process.env.NX_B2C_RESET_PASSWORD_POLICY ||
    process.env.NX?.NX_B2C_RESET_PASSWORD_POLICY,
  NX_B2C_EDIT_PROFILE_POLICY:
    process.env.NX_B2C_EDIT_PROFILE_POLICY ||
    process.env.NX?.NX_B2C_EDIT_PROFILE_POLICY,
  NX_CLIENT_ID: process.env.NX_CLIENT_ID || process.env.NX?.NX_CLIENT_ID,
  NX_SCOPES: process.env.NX_SCOPES || process.env.NX?.NX_SCOPES,

  NX_APPINSIGHTS_CONN_STR:
    process.env.NX_APPINSIGHTS_CONN_STR ||
    process.env.NX?.NX_APPINSIGHTS_CONN_STR,

  // From CI environment
  CI_BUILDNUMBER:
    process.env.NX_CI_BUILDNUMBER ||
    process.env.NX?.NX_CI_BUILDNUMBER ||
    'UNSET',
  CI_BUILDID:
    process.env.NX_CI_BUILDID || process.env.NX?.NX_CI_BUILDID || 'UNSET',
  CI_GIT_SHA:
    process.env.NX_CI_GIT_SHA || process.env.NX?.NX_CI_GIT_SHA || 'UNSET',

  NODE_ENV: process.env.NODE_ENV
}

window.env = env
